import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c6df02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "disabling-network-banner relative" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "banner-title mb-s2 sm:mb-s3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Blueshift is migrating to ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" BOB! ")
const _hoisted_8 = { class: "caption text-default" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" We will no longer support Milkomeda Cardano C1 and Cardano networks. Please withdraw your assets ")
const _hoisted_10 = { class: "white-space-nowrap" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("and bridge via ")

import ExternalLink from '@/components/ExternalLink.vue';
import { CHAIN_PORT_BRIDGE } from '@/constants/EXTERNAL_LINKS';
import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisablingNetworksBanner',
  setup(__props) {

const { state } = useStore();

const imgSrc = computed(() => `/images/disabling-networks/banner-img-${state.layout.viewMode}.png`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(imgSrc),
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (!_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Bitcoin on"))
          : _createCommentVNode("", true),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, [
          _hoisted_11,
          _createVNode(ExternalLink, {
            label: "ChainPort",
            url: _unref(CHAIN_PORT_BRIDGE),
            color: "info"
          }, null, 8, ["url"])
        ])
      ])
    ])
  ]))
}
}

})